"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
var react_1 = __importDefault(require("react"));
var Group_scss_1 = __importDefault(require("./Group.scss"));
var classnames_1 = __importDefault(require("classnames"));
var GroupContext_1 = require("./GroupContext");
var Group = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'block' : _c, props = __rest(_a, ["size"]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(Group_scss_1.default['au-group'], (_b = {},
            _b[Group_scss_1.default["au-group--width-".concat(size)]] = size && size != 'block',
            _b[Group_scss_1.default["au-group--block"]] = size == 'block',
            _b), props.className) }, props.items.map(function (r, i) { return (react_1.default.createElement(GroupContext_1.GroupContext.Provider, { value: { className: r.flex ? Group_scss_1.default['au-group-item--block'] : Group_scss_1.default['au-group-item--fixed'] }, key: i },
        react_1.default.createElement("div", { style: { flex: r.flex } }, r.element),
        r.separator ? react_1.default.createElement("div", { className: Group_scss_1.default['au-group-separator'] }) : react_1.default.createElement(react_1.default.Fragment, null))); })));
};
exports.Group = Group;
//# sourceMappingURL=Group.js.map